import * as React from 'react';

import { ExpandButton } from '../../components/ExpandButton';
import { CollapsedText } from '../../components/CollapsedText';

interface ICollapsedTextContainerProps {
  text: React.ReactNode;
  collapsedHeight?: number;
  button?: {
    expandText?: string;
    collapseText?: string;
  };
}

export const CollapsedTextContainer: React.FC<ICollapsedTextContainerProps> = ({ text, collapsedHeight, button }) => {
  const textRef = React.useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = React.useState(false);
  const [expandable, setExpandable] = React.useState(false);

  const toggleExpanded = React.useCallback(() => {
    setExpanded(!expanded);
  }, [expanded, setExpanded]);

  React.useEffect(() => {
    const textEl = textRef.current;

    /* istanbul ignore if */
    if (!textEl) {
      return;
    }

    const collapsedHeigh = textEl.offsetHeight;
    const fullHeigh = textEl.scrollHeight;

    setExpandable(fullHeigh > collapsedHeigh);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CollapsedText
        ref={textRef}
        text={text}
        collapsedHeight={collapsedHeight}
        expanded={expanded}
        expandable={expandable}
      />
      {expandable && (
        <ExpandButton
          expanded={expanded}
          onToggle={toggleExpanded}
          collapseText={button?.collapseText}
          expandText={button?.expandText}
        />
      )}
    </>
  );
};
